export default __webpack_public_path__ + "static/media/404.fdc5decd.svg";